const UploadButton = () => {
  const button = document.querySelector('.js-upload-button')
  if (button) {
    button.addEventListener('change', (event) => {
      console.log('change')
      document.querySelector('.js-upload-content').innerHTML = button.value.replace(/^.*\\/, '')
    })
  }
}

export default UploadButton



// WEBPACK FOOTER //
// ./src/js/modules/UploadButton.js